import { ReactNode } from 'react';
import { Box, Card, CardContent, Stack, Typography, Skeleton } from '@mui/joy';

interface StatCardProps {
  icon: ReactNode;
  value: number | string;
  label: string;
  color?: string;
  loading?: boolean;
}

export default function StatCard({ icon, value, label, color = 'primary.500', loading }: StatCardProps) {
  return (
    <Card>
      <CardContent>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              backgroundColor: color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            {icon}
          </Box>
          <Box sx={{ minWidth: 0 }}>
            {loading ? (
              <>
                <Skeleton variant="text" width={60} sx={{ fontSize: '1.5rem' }} />
                <Skeleton variant="text" width={100} sx={{ fontSize: '0.875rem' }} />
              </>
            ) : (
              <>
                <Typography level="h3">{value}</Typography>
                <Typography level="body-sm" color="neutral" noWrap>
                  {label}
                </Typography>
              </>
            )}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
